export default "__VITE_ASSET__4w6GBrz7__"